import React from "react";
import { Helmet } from "react-helmet-async";
import StHeroSection from "../components/StudentComponents/StHeroSection";
import StFaqSection from "../components/StudentComponents/StFaqSection"; 
import StDemoSection from "../components/StudentComponents/StDemoSection";
import StAdvantages from "../components/StudentComponents/StAdvantages";
import FeaturedClasses from "../components/StudentComponents/FeaturedClasses";
import WhyStrawket from "../components/StudentComponents/WhyStrawket";
import SignupSection from "../components/StudentComponents/SignupSection";
function Students() {
return(
    <div>

<Helmet>
        <title>Empower Students with Smart Learning | Strawket</title>
        <meta 
          name="description" 
          content="Find and compare top-rated learning institutes near you. Explore courses for academics, hobbies, and career skills—all on one trusted platform, Strawket." 
        />
        <meta 
          name="keywords" 
          content="Strawket for students, student learning platform, free demo classes, personalized education, online classes, featured learning, academic help" 
        />
        <link rel="canonical" href="https://strawket.com/students" />

        {/* Open Graph (for social sharing) */}
        <meta property="og:title" content="Find Top Learning Institutes Online | Strawket" />
        <meta 
          property="og:description" 
          content="Discover trusted academies and learning centers near you. Compare courses, read reviews, and join the best classes for your academic or skill journey." 
        />
        <meta property="og:url" content="https://strawket.com/students" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://strawket.com/static/media/logo.18f8cc4a64e05c1ba825.png" />
        <meta property="og:site_name" content="Strawket" />

        {/* Twitter Card (X) */}
        <meta name="twitter:title" content="Strawket for Students | Smarter Learning Starts Here" />
        <meta 
          name="twitter:description" 
          content="Explore Strawket’s platform designed for students – attend demo classes, discover benefits, and start your learning journey." 
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://www.strawket.com/assets/images/strawket-students-preview.png" />
      </Helmet>


        <StHeroSection />
        <WhyStrawket />
        <FeaturedClasses />
        <SignupSection />
        <StAdvantages />
        <StFaqSection />
        <StDemoSection />
    </div>
)
}
export default Students